import { BaseService } from "../../base";
export class ScheduleService extends BaseService {
  static get entity() {
    return "schedule";
  }
  static get name() {
    return "schedule";
  }

  static async getByConsultantId(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_consultant_id`, this.name, {
      consultant_id: data.consultant_id,
      state: data.state || "creada",
    });
  }
  static async getByProf(userId) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_prof/${userId}`, this.name);
  }

  /**
   * Es un show de schedule, pero los day_selected vienen solo con los campos id, schedule_id y date. Los schedule_detial
   * vienen con id, day_selected_id y state
   * @param {int} scheduleId  id de la agenda
   * @returns
   */
  static async getByIdPerformance(scheduleId) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/show_performance/${scheduleId}`, this.name);
  }

  static async getByIdPerformanceV2(scheduleId) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/show_performance_v2/${scheduleId}`, this.name);
  }

  /**
   *
   * @param {number} data.unity_node_id es la unidad de la agenda
   * @param {number} data.service_node_id  el servicio de la agenda
   * @param {boolean} data.is_active entrega las agendas activas
   * @param {number} data.professional_id
   * @param {number | null} data.consultant_id
   * @returns {Promise<Schedule[]>}
   */
  static async filter(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/filter`, this.name, data);
  }

  static async getByConsultantPerformance(data) {
    console.log("DATE", data);
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_consultant_id_performance`, this.name, {
      consultant_id: data.consultant_id ? data.consultant_id : data,
      state: data.state,
      day_selected_date: data.date_selected || null,
      professional_id: data.professional_id,
      date_start: data.filter_range ? data.date_start : null,
      date_end: data.filter_range ? data.date_end : null,
      archive_request: data.archive_request,
    });
  }

  //Esta esta creada solo para no tener conflictos la parte donde se selecciona la agenda al citar, porque hay una wea rara ahi que funciona, que yo hice :p salu2
  static async getByConsultantPerformance2(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_consultant_id_performance`, this.name, {
      consultant_id: data.consultant_id,
      state: data.state,
      day_selected_date: data.date_selected || null,
      professional_id: data.professional_id,
      archive_request: data.archive_request,
    });
  }
  static async getAvailabilityBySchedules(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/availability_by_schedules2`, "schedulesArray", {
      schedules: data.schedules,
      date: data.date,
      professional_id: data.professional_id,
      node_id: data.node_id,
    });
  }
  static async deleteSchedule(scheduleId) {
    return this.submit("delete", `${this.getApiUrlEntity(this.profile)}${this.entity}/delete_schedule/${scheduleId}`, this.name);
  }
  static async validateAvailabilitySchedule(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/validate_availability_schedule`, null, payload);
  }
}
